import { render, staticRenderFns } from "./tallaParaLaEdadNinas5a19A.vue?vue&type=template&id=5a528bc6&scoped=true&"
import script from "./tallaParaLaEdadNinas5a19A.vue?vue&type=script&lang=js&"
export * from "./tallaParaLaEdadNinas5a19A.vue?vue&type=script&lang=js&"
import style0 from "./tallaParaLaEdadNinas5a19A.vue?vue&type=style&index=0&id=5a528bc6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a528bc6",
  null
  
)

export default component.exports